export enum AccountPlan {
    FREE = 'FREE',
    ENTERPRISE = 'Enterprise',
    ENTERPRISE_TRIAL = 'Enterprise_Trial',
    MSP = 'MSP',
}
